import styled from 'styled-components';
import { CommonStyledComponentProps } from '__utils/type';
import { useMediaQuery } from 'react-responsive';
import React, { useState, useEffect } from 'react';
import congratsTick from 'images/LAMF_tick.svg';

const ThankYouContainer = styled.div<CommonStyledComponentProps>`
    *,p{
        font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? '14px' : '16px'};
        line-height: 1.5;
    }
    #anchorTag{
        color: #236df1;
        cursor: pointer;
    }
    .icon{
        width: ${(props: CommonStyledComponentProps) => props.isMobile ? '48px' : '32px'};
        height: ${(props: CommonStyledComponentProps) => props.isMobile ? '48px' : '32px'};
        flex-shrink: 0;
        margin-bottom: ${(props: CommonStyledComponentProps) => props.isMobile ? '20px' : '10px'};
    }
    .popup{
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        border-radius: var(--radius-md, 8px);
        position: relative;
        padding: var(--spacing-sp-16, 16px) var(--spacing-sp-24, 24px);
        justify-content: center;
        background: #081025;
        height: ${(props: CommonStyledComponentProps) => props.isMobile ? '207px' : '168px'};
    }
    .head{
        align-self: stretch;
        color: var(--color-netural-000, #FFF);
        font-family: var(--app-style-body, Roboto);
        font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? 'var(--app-size-fs-lg, 16px)' : 'var(--app-size-fs-lg, 18px)'}; 
        font-style: normal;
        font-weight: 500;
        line-height: ${(props: CommonStyledComponentProps) => props.isMobile ? 'var(--app-line-height-lh-md, 24px);' : 'var(--app-line-height-lh-md, 28px);'};  
        letter-spacing: ${(props: CommonStyledComponentProps) => props.isMobile ? '0.026px;' : ''}; 
        margin-bottom: ${(props: CommonStyledComponentProps) => props.isMobile ? '5px;' : ''};
    }
    .para{
        align-self: stretch;
        color: var(--color-tertiary-blue-200, #D3E5FC);
        font-family: var(--app-style-micro, Roboto);
        font-size: var(--app-size-fs-md, 14px);
        font-style: normal;
        font-weight: 400;
        line-height: var(--app-line-height-lh-sm, 20px);
        letter-spacing: 0.034px;
    }
`
const LAMFThankYouPopup: React.FC = () => {
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return (
        <div>
            <ThankYouContainer isMobile={isMobile}>
                <div className={`popup mt30 ${isMobile ? 'm16' : ''}`}>
                    <div>
                        <img className="icon" src={congratsTick} alt="success-icon" />
                    </div>
                    <p className = "head">Thank you for your interest in Loan Against Mutual Funds!</p>
                    <p className = "para">You will receive a call within 24 - 48 hours from our team</p>
                </div>
            </ThankYouContainer>
        </div>
    );
}

export default LAMFThankYouPopup